import { InputLabel } from "@mui/material";
import * as React from "react";
import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Rsl from "../Indicators/rsl";
import VolAnalysis from "../Indicators/volumeanalys";
import SMA from "../Indicators/sma";
import EMA from "../Indicators/ema";
import Returns from "../Indicators/returns";
import TechIndicator from "../Indicators/techindicators";
import { useDispatch, useSelector } from "react-redux";
import { SelectedDropdownOption } from "../../Redux/Action";
import { ActiveButton } from "../../Redux/Action";

const MobMenu = (props) => {
  const selectedExchange = useSelector((state) => state.SetExchange);
  const selectIndicator = useSelector((state) => state.SelectedDropdownOption);
  const selecttimeFrame = useSelector((state) => state.ActiveButton);
  const dispatch = useDispatch();

  const handleChangeExchange = (event) => {
    dispatch({ type: "SET_EXCHANGE", payload: event.target.value });
  };
  const handleChangeIndicator = (event) => {
    dispatch(SelectedDropdownOption(event.target.value));
  };
  const handleChangeTimeFrame = (event) => {
    dispatch(ActiveButton(event.target.value));
  };

  return (
    <>
      <div
        style={{ overflowX: "auto", whiteSpace: "nowrap", textAlign: "center" }}
      >
        <Box sx={{ display: "inline-block", textAlign: "center" }}>
          <FormControl
            variant="standard"
            sx={{ m: 1, minWidth: 100 }}
            disabled={selectIndicator === "Volume_Analysis"}
          >
            <InputLabel id="demo-simple-select-standard-label">
              {selectedExchange == "" ? "Xch" : ""}
            </InputLabel>
            <Select
              labelId="demo-simple-select-standard-label"
              id="demo-simple-select-standard"
              value={selectedExchange}
              onChange={handleChangeExchange}
              label="XCH"
            >
              <MenuItem value="NSE">NSE</MenuItem>
              <MenuItem value="BSE">BSE</MenuItem>
            </Select>
          </FormControl>
          <FormControl variant="standard" sx={{ m: 1, minWidth: 100 }}>
            <InputLabel id="demo-simple-select-standard-label">
              {selectIndicator == "" ? "Indicator's" : ""}
            </InputLabel>
            <Select
              labelId="demo-simple-select-standard-label"
              id="demo-simple-select-standard"
              value={selectIndicator}
              onChange={handleChangeIndicator}
              label="Indicator's"
            >
              <MenuItem value={"Indicator"}>Indicator</MenuItem>
              <MenuItem value={"SMA"}>SMA</MenuItem>
              <MenuItem value={"EMA"}>EMA</MenuItem>
              <MenuItem value={"RS_LEVEL_CLASSIC"}>R&S Level Classic</MenuItem>
              <MenuItem value={"RS_LEVEL_FIBBO"}>R&S Level Fibonacci</MenuItem>
              <MenuItem value={"Returns"}>Returns</MenuItem>
              <MenuItem value={"Volume_Analysis"}>Volume Analysis</MenuItem>
            </Select>
          </FormControl>
          <FormControl
            variant="standard"
            sx={{ m: 1, minWidth: 100 }}
            disabled={
              selectIndicator === "Returns" ||
              selectIndicator === "Volume_Analysis"
            }
          >
            <InputLabel id="demo-simple-select-standard-label">
              {selecttimeFrame == "" ? "Interval" : ""}
            </InputLabel>
            {/* {selectIndicator !== "Returns" &&
            selectIndicator !== "Volume_Analysis" ? (
              <> */}
            {selectIndicator === "RS_LEVEL_CLASSIC" ||
            selectIndicator === "RS_LEVEL_FIBBO" ? (
              <Select
                labelId="demo-simple-select-standard-label"
                id="demo-simple-select-standard"
                value={selecttimeFrame}
                onChange={handleChangeTimeFrame}
                label="Time Frame"
              >
                <MenuItem value={"Daily"}>1Dy</MenuItem>
                <MenuItem value={"Weekly"}>1Wk</MenuItem>
                <MenuItem value={"Monthly"}>1Mn</MenuItem>
              </Select>
            ) : (
              <Select
                labelId="demo-simple-select-standard-label"
                id="demo-simple-select-standard"
                value={selecttimeFrame}
                onChange={handleChangeTimeFrame}
                label="Time Frame"
              >
                <MenuItem value={"OneMinute"}>1Min</MenuItem>
                <MenuItem value={"FiveMinute"}>5Min</MenuItem>
                <MenuItem value={"FifteenMinute"}>15Min</MenuItem>
                <MenuItem value={"ThirtyMinute"}>30 Min</MenuItem>
                <MenuItem value={"OneHour"}>1Hr</MenuItem>
                <MenuItem value={"Daily"}>1Dy</MenuItem>
                <MenuItem value={"Weekly"}>1Wk</MenuItem>
                <MenuItem value={"Monthly"}>1Mn</MenuItem>
              </Select>
            )}
            {/* </>
            ) : (
              ""
            )} */}
          </FormControl>
        </Box>
      </div>
    </>
  );
};
export default MobMenu;
